// extracted by mini-css-extract-plugin
module.exports = {"list-item":"l_Y","list-item--navitem":"l_Z"};